import { render, staticRenderFns } from "./SearchPluginCustom.vue?vue&type=template&id=2919b620&scoped=true"
import script from "./SearchPluginCustom.vue?vue&type=script&lang=ts"
export * from "./SearchPluginCustom.vue?vue&type=script&lang=ts"
import style0 from "./SearchPluginCustom.vue?vue&type=style&index=0&id=2919b620&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2919b620",
  null
  
)

export default component.exports